// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__8mIWa","row":"Node_row__2XM6Y","label":"Node_label__2D7yO","footer":"Node_footer__1PcPA"};